export const INIT_LOCAL_REPLY_DRAFT = 'INIT_LOCAL_REPLY_DRAFT'

export const UPDATE_LOCAL_REPLY_DRAFT = 'UPDATE_LOCAL_REPLY_DRAFT'

export const SAVE_REPLY_DRAFT_REQUEST = 'SAVE_REPLY_DRAFT_REQUEST'
export const SAVE_REPLY_DRAFT_FAIL = 'SAVE_REPLY_DRAFT_FAIL'
export const SAVE_REPLY_DRAFT_COMPLETE = 'SAVE_REPLY_DRAFT_COMPLETE'

export const UPDATE_NOTE_DRAFT = 'UPDATE_NOTE_DRAFT'
export const UPDATE_NOTE_DRAFT_RECIPIENT = 'UPDATE_NOTE_DRAFT_RECIPIENT'
export const NOTE_DRAFT_BODY_CHANGED = 'NOTE_DRAFT_BODY_CHANGED'

export const UPDATE_REPLY_DRAFT_RECIPIENTS = 'UPDATE_REPLY_DRAFT_RECIPIENTS'
export const UPDATE_MULTIPLE_DRAFT_RECIPIENTS =
  'UPDATE_MULTIPLE_DRAFT_RECIPIENTS'
export const ADD_REPLY_DRAFT_RECIPIENTS = 'ADD_REPLY_DRAFT_RECIPIENTS'
export const REMOVE_REPLY_DRAFT_RECIPIENTS = 'REMOVE_REPLY_DRAFT_RECIPIENTS'
export const UPDATE_REPLY_DRAFT_RECIPIENT_QUERY =
  'UPDATE_REPLY_DRAFT_RECIPIENT_QUERY'
export const SELECT_DRAFT_RECIPIENT = 'SELECT_DRAFT_RECIPIENT'
export const CLEAR_SELECTED_DRAFT_RECIPIENT = 'CLEAR_SELECTED_DRAFT_RECIPIENT'

export const INVALIDATE_REPLY_DRAFT = 'INVALIDATE_REPLY_DRAFT'
export const INVALIDATE_NOTE_DRAFT = 'INVALIDATE_NOTE_DRAFT'

export const SEND_REPLY = 'SEND_REPLY'
export const SEND_REPLY_COMPLETE = 'SEND_REPLY_COMPLETE'
export const SEND_REPLY_FAIL = 'SEND_REPLY_FAIL'

export const SEND_NOTE = 'SEND_NOTE'
export const SEND_NOTE_COMPLETE = 'SEND_NOTE_COMPLETE'
export const SEND_NOTE_FAIL = 'SEND_NOTE_FAIL'
